var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChartLine4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE2\x98\xA0\xEF\xB8\x8F chart-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4999 2.66675C22.7091 2.66675 24.4999 4.45761 24.4999 6.66675C24.4999 7.68106 24.1224 8.60719 23.5002 9.31229L26.8509 16.0124C26.955 16.0042 27.0603 16.0001 27.1666 16.0001C29.3757 16.0001 31.1666 17.7909 31.1666 20.0001C31.1666 22.2092 29.3757 24.0001 27.1666 24.0001C24.9574 24.0001 23.1666 22.2092 23.1666 20.0001C23.1666 18.9858 23.5441 18.0596 24.1663 17.3545L20.8156 10.6545C20.7115 10.6626 20.6062 10.6667 20.4999 10.6667L20.4185 10.6659L15.34 22.5166C16.057 23.2396 16.4999 24.2348 16.4999 25.3334C16.4999 27.5426 14.7091 29.3334 12.4999 29.3334C10.2908 29.3334 8.49992 27.5426 8.49992 25.3334C8.49992 24.3191 8.87745 23.393 9.49967 22.6879L6.14898 15.9878C6.04481 15.9959 5.93951 16.0001 5.83325 16.0001C3.62411 16.0001 1.83325 14.2092 1.83325 12.0001C1.83325 9.79094 3.62411 8.00008 5.83325 8.00008C8.04239 8.00008 9.83325 9.79094 9.83325 12.0001C9.83325 13.0144 9.45572 13.9405 8.8335 14.6456L12.1828 21.3458L12.3406 21.3365L12.5791 21.3342L17.6599 9.48352C16.9428 8.7606 16.4999 7.7654 16.4999 6.66675C16.4999 4.45761 18.2908 2.66675 20.4999 2.66675Z",
    fill: "#5289AA"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartLine4);
export default __webpack_public_path__ + "static/media/chart-line-4.fc92a731.svg";
export { ForwardRef as ReactComponent };